// extracted by mini-css-extract-plugin
module.exports = {"BoyWithBackpack":"TextGroupSectionC_BoyWithBackpack__1RdWe","TextContainer":"TextGroupSectionC_TextContainer__2jaaU"};